import { render, staticRenderFns } from "./DeveloperGuide.vue?vue&type=template&id=3601b4c4&scoped=true"
import script from "./DeveloperGuide.vue?vue&type=script&lang=js"
export * from "./DeveloperGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3601b4c4",
  null
  
)

export default component.exports